const resources = {
    title: 'AI Beauty Chat',
    placeholder: 'Message...',
    shareFeedback: 'Share Feedback',
    new: 'NEW',
    addToBasket: 'Add to Basket',
    size: 'Size',
    errorMessage: 'Something went wrong. Please try restarting the chat or',
    resendYourMessage: 'resend your message',
    lookingForAGift: 'I am looking for a gift!',
    startChat: 'Start a Chat',
    tryAsking: 'Try Asking',
    topHairCareQuestions: 'Top Hair Care Questions',
    topSkincareQuestions: 'Top Skincare Questions',
    topMakeupQuestions: 'Top Makeup Questions',
    topFragranceQuestions: 'Top Fragrance Questions',
    topBathBodyQuestions: 'Top Bath & Body Questions',
    description: 'Powered by millions of reviews, exclusive product info, and your personal beauty preferences.',
    feedback: 'Feedback',
    added: 'Added',
    free: 'FREE',
    points: 'Points',
    purchasedOn: 'PURCHASED ON',
    color: 'Color:',
    shade: 'Shade:',
    variant: 'Variant:',
    viewAll: 'View All'
};

export default function getResource(label) {
    return resources[label];
}
